// Küçük yardımcılar (WorkOrderEmail bileşenleri için).
import moment from 'moment';

export const formatDateTime = iso => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString();
};

export const formatSize = bytes => {
  if (typeof bytes !== 'number' || bytes < 0) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

/** Tarayıcıda Blob'u dosya olarak kaydeder. */
export const saveBlob = (blob, fileName) => {
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, fileName);
    return;
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 10000);
};

// Yalnızca bu türler tarayıcıda açılır (aktif belge türleri sunucuda octet-stream'e çevrilir).
export const isViewableType = contentType =>
  /^image\/(png|jpe?g|gif|webp|bmp)$/i.test(contentType || '') ||
  /^application\/pdf$/i.test(contentType || '');

/** Blob'u, yalnızca güvenli bir türle sarıp yeni sekmede açar. */
export const openBlob = (blob, contentType) => {
  const safe = new Blob([blob], { type: contentType });
  const url = URL.createObjectURL(safe);
  window.open(url, '_blank');
  setTimeout(() => URL.revokeObjectURL(url), 60000);
};

/** "10 min ago" gibi göreli zaman (moment yerel ayarına göre); geçersiz değerde boş döner. */
export const formatRelative = iso => {
  if (!iso) return '';
  const m = moment(iso);
  return m.isValid() ? m.fromNow() : '';
};

const messageTime = m => {
  const iso = m.direction === 'Outbound' ? m.sentAtUtc || m.receivedAtUtc : m.receivedAtUtc || m.sentAtUtc;
  const ms = iso ? new Date(iso).getTime() : NaN;
  return Number.isNaN(ms) ? 0 : ms;
};

/** Mesajları tek bir tarihe göre sıralar (giden: sentAtUtc, gelen: receivedAtUtc); eşitlikte kimlik ile kararlı. */
export const sortMessagesByDate = (messages, newestFirst) => {
  const dir = newestFirst ? -1 : 1;
  return [...(messages || [])].sort((a, b) => {
    const diff = messageTime(a) - messageTime(b);
    if (diff !== 0) return diff * dir;
    return String(a.conversationMessageId).localeCompare(String(b.conversationMessageId)) * dir;
  });
};
